import { render, staticRenderFns } from "./riseRateRecord.vue?vue&type=template&id=2d2316f4&"
import script from "./riseRateRecord.vue?vue&type=script&lang=js&"
export * from "./riseRateRecord.vue?vue&type=script&lang=js&"
import style0 from "./riseRateRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports